import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInOut } from '../sidenav.interface';
import { LISTS, MAPS, TRACE } from 'src/app/shared/routeLink.constant';
import { UtilService } from 'src/app/core/services/util.service';

@Component({
  selector: 'app-sublevel-menu',
  templateUrl: './sublevel-menu.component.html',
  styleUrls: ['./sublevel-menu.component.scss'],
  standalone: false,
  animations: [
    fadeInOut,
    trigger('submenu', [
      state('hidden', style({ height: '0', overflow: 'hidden' })),
      state('visible', style({ height: '*' })),
      transition('visible <=> hidden', [
        style({ overflow: 'hidden' }),
        animate('{{transitionParams}}'),
      ]),
      transition('void => *', animate(0)),
    ]),
  ],
})
export class SublevelMenuComponent implements OnInit {
  showMoreItems = false;
  visibleItems: any[] = [];
  remainingItems: any[] = [];
  showMore = false;
  @Input() data: any = {};
  @Input() collapsed = false;
  @Input() animating: boolean | undefined;
  @Input() expanded: boolean | undefined;
  @Input() multiple = false;
  svgPath = 'assets/img/common/';

  constructor(
    public router: Router,
    private readonly utils: UtilService
  ) {}

  ngOnInit(): void {
    this.visibleItems = this.data.items ?? [];
  }

  showDropdown(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const dropdownMenu = target.querySelector('.dropdown-menu') as HTMLElement;
    dropdownMenu.style.display = 'block';
  }

  getIconClass(data: any) {
    switch (data.icon) {
      case 'TrackingIcon':
        return 'fa fa-globe';
      case 'DashboardIcon':
        return 'fa fa-home';
      case 'ReportsIcon':
        return 'fa fa-flag';
      case 'AlertsIcon':
        return 'fa fa-bell';
      case 'AdminIcon':
        return 'fa fa-user-circle';
      case 'LogsIcon':
        return 'fa fa-cogs';
      case 'HelpdeskIcon':
        return 'fa fa-ticket';
      default:
        return 'fa fa-user-circle';
    }
  }
  hideDropdown(event: MouseEvent) {
    const target = event.currentTarget as HTMLElement;
    const dropdownMenu = target.querySelector('.dropdown-menu') as HTMLElement;
    dropdownMenu.style.display = 'none';
  }

  handleClick(item: any): void {
    if (!this.multiple) {
      if (this.data.items && this.data.items.length > 0) {
        for (const modelItem of this.data.items) {
          if (item !== modelItem && modelItem.expanded) {
            modelItem.expanded = false;
          }
        }
      }
    }
    item.expanded = !item.expanded;
    this.updateTypeAndStatus(item);
  }

  updateTypeAndStatus(item: any) {
    // setting state for mapview and list view
    if (item.route_link == `${TRACE}/${LISTS}`) {
      this.utils.updateViewType(LISTS);
    }
    if (item.route_link == `${TRACE}/${MAPS}`) {
      this.utils.updateViewType(MAPS);
    }

    //update the status to all if user is not click on mapview or listview
    if (
      item.route_link != `${TRACE}/${LISTS}` &&
      item.route_link != `${TRACE}/${MAPS}`
    ) {
      this.utils.updateVehicleLegendStatus('All');
    }
  }

  getActiveClass(item: any): string {
    return item.expanded && this.router.url.includes(item.route_link)
      ? 'active-sublevel'
      : '';
  }

  getActiveClassCollpase(item: any): string {
    return item.expanded && this.router.url.includes(item.route_link)
      ? 'active-sublevel-closed'
      : '';
  }
  toggleMoreItems(): void {
    this.showMore = !this.showMore;
    if (this.showMore) {
      this.visibleItems = this.data.items ?? [];
    } else {
      this.visibleItems = this.data.items ? this.data.items.slice(0, 3) : [];
    }
  }

  getImageSrc(data: any): string {
    return `${this.svgPath}sprite.svg#${data}`;
  }
}
